import React from "react";
import { IconRightMove } from "./svgs";


interface TableHeaderProps {
  title: string;
  actionText?: string;
  onClick?: () => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  title,
  actionText,
  onClick,
}) => {
  return (
    <div className="h-[21px]">
      <div className="flex h-[21px] items-center justify-between">
        <div className="pl-[8px] text-[18px] font-normal leading-none text-white">{title}</div>
        {actionText && actionText.length > 0 && (
          <div className="flex cursor-pointer items-center text-sm leading-none text-text_secondary" onClick={onClick}>
            <span>{actionText}</span>
            <IconRightMove />
          </div>
        )}
      </div>
    </div>
  );
};

export default TableHeader;
